<div class="collapseWrap summarycollection container">
		<!-- container section -->
	<!-- account collapse -->
	<div class="collapseBlock clear personal-summary summary hidethis" [routerLink]="['personal']">
		<div class="nav-icons aboutme" [routerLink]="['personal']"><i class="fa fa-chevron-down fa-2x"></i></div>
		<h1 class="aboutme">Personal Information</h1>
		<p>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
		</p>
		<!-- <div class="nav-arrow">
			<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
		</div> -->
		<!-- <a class="mainbtn asrow" [routerLink]="['personal']" title="Edit this section"></a> -->
	</div>
	<!-- /account collapse -->
	<!-- membership collapse -->
	<div class="collapseBlock clear membership-summary summary hidethis" [routerLink]="['membership']">
		<div class="nav-icons membership" [routerLink]="['membership']"><i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i></div>
		<h1 class="membership">Membership</h1>
		<p>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
		</p>
		<!-- <div class="nav-arrow">
			<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
		</div> -->
		<!-- <p>
			<a class="mainbtn" [routerLink]="['membership']" title="Edit this section">Edit
				<span class="arrowD"></span>
			</a>
		</p> -->
	</div>
	<!-- /membership collapse -->
	<!-- education collapse -->
	<div class="collapseBlock clear education-summary summary hidethis" [routerLink]="['education']">
		<div class="nav-icons education"  [routerLink]="['education']"><i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i></div>
		<h1 class="education">Education and Credentials</h1>
		<p>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
		</p>
		<!-- <div class="nav-arrow">
			<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
		</div> -->
		<!-- <p>
			<a class="mainbtn" [routerLink]="['education']" title="Edit this section">Edit
				<span class="arrowD"></span>
			</a>
		</p> -->
	</div>
	<!-- education collapse -->

	<!-- chapter collapse -->
	<div class="collapseBlock clear chapters-summary summary hidethis" [routerLink]="['chapters']">
		<div class="nav-icons chapters" [routerLink]="['chapters']"><i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i></div>
		<h1 class="chapters">Chapter</h1>
		<p>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
		</p>
		<!-- <div class="nav-arrow">
			<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
		</div> -->
		<!-- <p>
			<a class="mainbtn" [routerLink]="['chapters']" title="Edit this section">Edit
				<span class="arrowD"></span>
			</a>
		</p> -->
	</div>
	<!-- chapter collapse -->
	<!-- section collapse -->
	<div class="collapseBlock clear sections-summary summary hidethis" [routerLink]="['sections']">
		<div class="nav-icons sections" [routerLink]="['sections']"><i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i></div>
		<h1 class="sections">Sections</h1>
		<p>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
		</p>
		<!-- <div class="nav-arrow">
			<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
		</div> -->
		<!-- <p>
			<a class="mainbtn" [routerLink]="['sections']" title="Edit this section">Edit
				<span class="arrowD"></span>
			</a>
		</p> -->
	</div>
	<!-- section collapse -->
	<!-- shoppingcart collapse -->
	<div class="collapseBlock clear checkout-summary summary hidethis" [routerLink]="['checkout']">
		<div class="nav-icons checkout" [routerLink]="['checkout']"><i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i></div>
		<h1 class="checkout">Summary and Checkout</h1>
		<p>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
			<span class="labelBlock">Input Label Text Here</span>
		</p>
		<!-- <div class="nav-arrow">
			<i class="fa fa-chevron-down fa-2x" aria-hidden="true"></i>
		</div> -->
		<!-- <p>
			<a class="mainbtn" [routerLink]="['checkout']" title="Edit this section">Edit
				<span class="arrowD"></span>
			</a>
		</p> -->
	</div>
	<!-- shoppingcart collapse -->
</div>
